// extracted by mini-css-extract-plugin
module.exports = {"chart-container":"salaryChart_chart-container__XyMp1"};